import { generatePath } from 'react-router';
import { makeObservable, observable } from 'mobx';

import { CollectionType } from '@/collection/entity/CollectionType';
import { NOT_FOUND_PAGE } from '@/common/constants/pages';
import { assignModel } from '@/common/helpers/assignModel';
import URLProvider from '@/common/services/URLProvider';
import { DriveItemPreview } from '@/drive/entities/DriveItem/DriveItemPreview';
import { DriveItemId } from '@/drive/entities/DriveItemId';

import { BaseDriveItem, DriveItemType } from './DriveItem.types';

export interface BaseCollectionItemModel {
  id: DriveItemId;
  title: string;
  type: DriveItemType;
  description?: string;
  preview?: Nullable<DriveItemPreview>;
  canEdit: boolean;
  canManageAccess: boolean;
  collectionType: CollectionType;
  collectionId?: string;
  count: number;
  createdAt?: string;
}

export abstract class BaseCollectionItem extends BaseDriveItem {
  collectionType!: CollectionType;
  collectionId?: string;
  count!: number;

  constructor(model: BaseCollectionItemModel) {
    super();

    makeObservable(this, {
      collectionType: observable,
      collectionId: observable,
      count: observable,
    });

    assignModel<BaseCollectionItemModel>(this, model);
  }

  getLinkData() {
    return {
      isExternal: false,
      url: this.collectionId
        ? URLProvider.collectionDetailPage({ id: this.collectionId })
        : generatePath(NOT_FOUND_PAGE),
    };
  }

  override canBeShared(): boolean {
    return !!this.collectionId;
  }
}
